<template>
  <div>
    <div class="m-2 text-center">
      <b-spinner />
      <div class="mt-1">
        <small>Yükleniyor..</small>
      </div>
    </div>
  </div>
</template>
<script>

import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'Loading',
  components: { BSpinner },
}
</script>
